export default __webpack_public_path__ + "static/media/map.481a0468.png";